export default {"src":"/_next/static/media/campusInviteWorking2.27cbbc48.svg","height":205,"width":418,"blurWidth":0,"blurHeight":0};